import { render, staticRenderFns } from "./UnCheckedRadioIcon.vue?vue&type=template&id=de47b9f8"
import script from "./UnCheckedRadioIcon.vue?vue&type=script&lang=js"
export * from "./UnCheckedRadioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports